<template>

    <app-layout>


        <div class="-mt-6 flex flex-grow flex-col relative">

            <div class="absolute top-0 left-0 w-full h-full flex flex-grow flex-col opacity-20"></div>

            <div class=" z-10 flex flex-col mx-auto justify-center items-center flex-grow ">

                <LockClosedIcon class="size-8 text-gray-800" />

                <h4 class="text-center text-base mt-3 text-gray-800">For privacy reasons,
                    this video is only accessible to members of {{ team_name }} </h4>

                <div class="text-center font-light text-lg mt-6 text-gray-500">
                    <a :href="redirect" title="Sign in"
                        class="inline-flex items-center px-4 py-2 bg-birdie-dark  border-transparent rounded-md font-bold text-sm text-white uppercase tracking-widest hover:opacity-90  disabled:opacity-25 transition">Sign-in
                        <ArrowRightIcon class="w-4 h-4 ml-2" />
                    </a>
                </div>



            </div>


            <div class="relative w-full bg-blue-500 text-white text-center py-6" v-if="footer_view">
                <a href="#" @click.prevent.stop="footer_view = false"
                    class="absolute top-3 right-4 h-4 w-4 hover:text-blue-800" title="Close">
                    <vue-feather type="x" class="h-4 w-4"></vue-feather>
                </a>

                <h5 class="text-2xl font-semibold">Secure screen recording for modern Support teams and their customers.
                </h5>
                <p class="text-lg font-medium">Speed up resolution and provide an outstanding experience.</p>
                <p class="mt-3">
                    <a :href="'https://www.' + domain" taget="_blank" :title="'Add ' + app_name + ' to your helpdesk'"
                        class="mt-3 inline-flex items-center px-4 py-2 bg-white border-2 border-transparent rounded-md font-bold text-sm text-blue-500 uppercase tracking-widest hover:bg-blue-500 hover:text-white hover:border-white active:bg-blue-500 focus:outline-none focus:border-white focus:ring focus:ring-white disabled:opacity-25 transition">
                        Add {{ app_name }} to your helpdesk
                    </a>
                </p>
            </div>


        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { LockClosedIcon, ArrowRightIcon } from "@heroicons/vue/24/outline";


export default {
    props: ["team_name", "redirect"],

    components: {
        AppLayout, LockClosedIcon, ArrowRightIcon
    },
    data() {
        return {
            footer_view: false,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name
        }
    },
    created() {
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
        //console.log(this.is_visitor)
    },
    beforeUnmount() {
        // this.EventBus.off("start.call", this.test);
    },
    mounted() {
        // this.EventBus.emit("start.call", "hello")
    },
    methods: {
        // test(toto) {
        //     console.log("test ok", toto)
        // }
    }
}
</script>
